<template>
    <div style="max-width:70%; display:block; margin:auto; height:250px!important;">
        <canvas ref="chart"></canvas>
    </div>
</template>

<script>
    import {Chart} from 'chart.js';
    export default{

        props:[
            'sectors'
        ],

        data() {
            return {
                colors_list: [
                    "rgba(56, 103, 214, 1)",
                    "rgba(56, 103, 214, .9)",
                    "rgba(56, 103, 214, .8)",
                    "rgba(56, 103, 214, .7)",
                    "rgba(56, 103, 214, .6)",
                    "rgba(56, 103, 214, .5)",
                    "rgba(56, 103, 214, .4)",
                    "rgba(56, 103, 214, .3)"
                ]
            }
        },


        mounted(){
            var ctx = this.$refs.chart.getContext('2d');

            var labels  = [];
            var values = [];
            var colors = [];
            var color_index = 0;
            this.sectors.forEach(sector=>{
                labels.push(sector.name);
                values.push(Math.round(sector.value,0));
                colors.push(this.colors_list[color_index]);
                color_index++;
                if (color_index == this.colors_list.length)
                {
                    color_index = 0;
                }
            });

            var myChart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: values,
                            backgroundColor: colors,

                        }
                    ]
                },
                labels: labels,
                options: {
                    maintainAspectRatio: false,
                    cutoutPercentage: 70,
                    responsive: true,
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return data.labels[tooltipItem.index] + ' : ' + Math.round(data.datasets[0].data[tooltipItem.index] * 100) / 100 + '%';
                            }
                        }
                    },
                    legend: {
                        position: 'right',
                        display: false,
                        labels: {
                            fontFamily: 'Lato',
                            fontSize: 12,
                            fontStyle: 'bold',
                            padding: 10,
                            boxWidth: 10
                                }
                    },
                }
            });
        }
    }
</script>